import { useState } from "react";
import { Flag, X } from "@phosphor-icons/react";

const PRESETS = ["Main Stage", "Food Trucks", "The Bar", "Entrance", "Our Camp", "Toilets"];

export default function SpotDialog({ open, onConfirm, onCancel }) {
  const [label, setLabel] = useState("");
  if (!open) return null;

  const submit = () => {
    onConfirm((label || "").trim() || "Meet Here");
    setLabel("");
  };

  return (
    <div className="fixed inset-0 z-[78] flex items-end justify-center bg-black/60 sm:items-center" data-testid="spot-dialog">
      <div className="w-full max-w-md border-2 border-black bg-white shadow-[8px_8px_0px_rgba(0,0,0,1)]">
        <div className="flex items-center justify-between border-b-2 border-black bg-accent px-4 py-3 text-white">
          <h2 className="flex items-center gap-2 font-heading text-base font-black uppercase tracking-tight">
            <Flag weight="fill" size={20} /> Name this spot
          </h2>
          <button data-testid="spot-cancel" onClick={onCancel} className="grid h-9 w-9 place-items-center border-2 border-black bg-white text-black">
            <X weight="bold" size={18} />
          </button>
        </div>

        <div className="p-4">
          <input
            data-testid="spot-name-input"
            value={label}
            onChange={(e) => setLabel(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && submit()}
            placeholder="e.g. Main Stage"
            maxLength={28}
            autoFocus
            className="mb-3 h-14 w-full border-2 border-black bg-white px-3 font-mono2 text-lg font-semibold outline-none placeholder:text-black/30"
          />

          <p className="mb-2 font-mono2 text-[10px] font-bold uppercase tracking-[0.2em] text-black/40">Quick picks</p>
          <div className="mb-4 flex flex-wrap gap-2">
            {PRESETS.map((p) => (
              <button
                key={p}
                data-testid={`spot-preset-${p.replace(/\s+/g, "-").toLowerCase()}`}
                onClick={() => setLabel(p)}
                className={`border-2 border-black px-3 py-1.5 font-mono2 text-xs font-bold uppercase shadow-[2px_2px_0px_rgba(0,0,0,1)] transition-transform duration-150 ease-out active:translate-x-[2px] active:translate-y-[2px] active:shadow-none ${
                  label === p ? "bg-primary" : "bg-white"
                }`}
              >
                {p}
              </button>
            ))}
          </div>

          <button
            data-testid="spot-confirm"
            onClick={submit}
            className="flex h-14 w-full items-center justify-center gap-2 border-2 border-black bg-primary font-heading text-base font-bold uppercase shadow-[4px_4px_0px_#18181B] transition-transform duration-150 ease-out active:translate-x-[3px] active:translate-y-[3px] active:shadow-none"
          >
            <Flag weight="fill" size={18} /> Drop it here
          </button>
        </div>
      </div>
    </div>
  );
}
